import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Triggers from './pages/Triggers';
import PipelineEditor from './pages/PipelineEditor';
import Services from './pages/Services';
import Environments from './pages/Environments';
import Builds from './pages/Builds';
import BuildDetail from './pages/BuildDetail';
import WorkflowView from './pages/WorkflowView';
import { authApi } from './api/client';

function RequireAuth({ children }) {
  const [status, setStatus] = useState('checking'); // checking | ok | denied

  useEffect(() => {
    authApi.check()
      .then(r => setStatus(r.authenticated ? 'ok' : 'denied'))
      .catch(() => setStatus('denied'));
  }, []);

  if (status === 'checking') {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 size={24} className="text-accent-purple animate-spin" />
      </div>
    );
  }
  if (status === 'denied') return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/workflow" element={<RequireAuth><WorkflowView /></RequireAuth>} />
        <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="triggers" element={<Triggers />} />
          <Route path="triggers/new" element={<PipelineEditor />} />
          <Route path="triggers/:id/edit" element={<PipelineEditor />} />
          <Route path="services" element={<Services />} />
          <Route path="environments" element={<Environments />} />
          <Route path="builds" element={<Builds />} />
          <Route path="builds/:buildId" element={<BuildDetail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
